import {z} from '@hono/zod-openapi';

import {advertisementPayloadSchema} from './AdvertisementPayloadSchema';
import {advertisingCredentialsSchema} from './AdvertisingCommonSchemas';

export const automarketplEquipmentRequestSchema = z
  .object({
    tenantId: z.string().uuid(),
    credentials: advertisingCredentialsSchema.nullable(),
    vehicle: advertisementPayloadSchema,
  })
  .openapi('AutomarketplEquipmentRequest');
